module.exports = __webpack_public_path__ + "img/Zain-KSA-Ar.e8f881ad.jpg";